import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Guards
import { AuthGuard } from './services/guards/auth.guard';

// Componentes
import { AuthComponent } from './layout/auth/auth.component';
import { AdminComponent } from './layout/admin/admin.component';
import { NopagefoundComponent } from './theme/nopagefound/nopagefound.component';




const routes: Routes = [
    {
        path: '',
        component: AuthComponent,
        children: [
            {
                path: '',
                redirectTo: 'auth',
                pathMatch: 'full'
            },
            {
                path: 'auth',
                loadChildren: './theme/auth/auth.module#AuthModule'
            }
        ]
    },
    {
       path: '',
       component: AdminComponent,
       canActivate: [AuthGuard],
       children: [
            {
                path: '',
                redirectTo: 'administracion',
                pathMatch: 'full'
            },
            {
                path: 'administracion',
                loadChildren: './theme/administracion/administracion.module#AdministracionModule'
            },
            {
                path: 'dashboard',
                loadChildren: './theme/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'monitoreo',
                loadChildren: './theme/monitoreo/monitoreo.module#MonitoreoModule'
            },
            {
                path: 'reportes',
                loadChildren: './theme/reportes/reportes.module#ReportesModule'
            },
            {
                path: 'visitas',
                loadChildren: './theme/visita/visita.module#VisitaModule'
            },
            {
                path: 'usuario',
                loadChildren: './theme/user/user.module#UserModule'
            },
            {
                path: 'eventos',
                loadChildren: './theme/eventos/eventos.module#EventosModule'
            },
            {
                path: 'instalacion1',
                loadChildren: './theme/instalacion/instalacion.module#InstalacionModule'
            },
            {
                path: 'instalacion',
                loadChildren: './theme/instalacion/instalacion.module#InstalacionModule'
            },
            {
                path: 'testabonado',
                loadChildren: './theme/testabonado/testabonado.module#TestabonadoModule'
            },
            {
                path: 'abonados',
                loadChildren: './theme/abonados/abonados.module#AbonadosModule'
            },
            {
                path: 'inicio',
                loadChildren: './theme/inicio/inicio.module#InicioModule'
            },
            {
                path: 'cuenta',
                loadChildren: './theme/cuenta/cuenta.module#CuentaModule'
            }

       ]
    },
    {
        path: '**',
        component: NopagefoundComponent
    }

];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [ RouterModule]
})
export class AppRoutingModule { }
